<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 24 24"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.6475 11.4135L10.1279 6.11341C9.65796 5.82432 9 6.11341 9 6.6916V17.2917C9 17.9663 9.65796 18.159 10.1279 17.8699L17.6475 12.6662C18.1175 12.3771 18.1175 11.7026 17.6475 11.4135Z" :fill="fill"/>
    <circle cx="12" cy="12" r="11" :stroke="fill" stroke-width="2"/>
  </svg>

</template>

<script>
export default {
  name: 'Play',
  props: {
    width: {
      type: String,
      required: false,
      default: '11px'
    },
    height: {
      type: String,
      required: false,
      default: '11px'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
